import React from 'react'
import { useLocation } from 'react-router-dom'
import useAuth from 'app/hooks/useAuth'
import useSaAccess from 'app/hooks/useSaAccess'
import AccessRestricted from 'app/components/AccessRestricted'
import { MatxLoading } from 'app/components'

/**
 * Blocks SA users from routes outside their sectionAccess (read/write).
 * Non-SA roles pass through. Personal account settings always allowed.
 */
const SaAccessGuard = ({ children }) => {
    const { user, isInitialised } = useAuth()
    const { canAccessPath } = useSaAccess()
    const location = useLocation()

    if (!isInitialised || !user) {
        return <MatxLoading />
    }

    if (user.role !== 'SA') {
        return <>{children}</>
    }

    const path = location.pathname || ''
    // Always allow own account/password settings for every SA
    if (
        path.startsWith('/settings/account-settings') ||
        path.startsWith('/settings/user-profile')
    ) {
        return <>{children}</>
    }

    if (!canAccessPath(path)) {
        return <AccessRestricted />
    }

    return <>{children}</>
}

export default SaAccessGuard
